export default function min(enumerable, selector) {
    const values = enumerable.select(selector);
    return Math.min(...values);
}
